import { render, staticRenderFns } from "./AssociationPill.vue?vue&type=template&id=7976555f&scoped=true"
import script from "./AssociationPill.vue?vue&type=script&lang=js"
export * from "./AssociationPill.vue?vue&type=script&lang=js"
import style0 from "./AssociationPill.vue?vue&type=style&index=0&id=7976555f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7976555f",
  null
  
)

export default component.exports